module.exports = __webpack_public_path__ + "static/media/superai_symbol_white_md.34c560c5.png";